import AccountView from "Components/Account/AccountView";
import BillingView from "Components/Billing/BillingView";
import ConfigView from "Components/Configuration/ConfigView";
import GlobalNumberView from "Components/GlobalNumber/GlobalNumberView";
import OrganisationView from "Components/Organisation/OrganisationView";
import SecurityView from "Components/Role/SecurityView";
import Header from "Components/Shared/Header";
import TicketView from "Components/Ticket/TicketView";
import useCheckRole from "Hooks/APICheckRole";
import APIAccountProvider from "Providers/APIAccountProvider";
import APINumberPoolProvider from "Providers/APINumberPoolProvider";
import APIOrganisationProvider from "Providers/APIOrganisationProvider";
import APIRoleProvider from "Providers/APIRoleProvider";
import APITicketProvider from "Providers/APITicketProvider";
import React from "react";
import "./App.css";

const App = () => {
  const { hasRole, roles } = useCheckRole();

  const getView = () => {
    const hasAccounts = hasRole(roles.account.roles.view);
    const hasOrg = hasRole(roles.organisation.roles.view);
    const hasBilling = hasRole(roles.billing.roles.view);
    const hasSecurity = hasRole(roles.security.roles.view);
    const hasTickets = hasRole(roles.ticket.roles.view);
    const hasGlobalNumbers = hasRole(roles.ticket.roles.view);
    const hasConfig = hasRole(roles.config.roles.view);
    if (hasAccounts) return "accounts";
    if (hasOrg) return "organisation";
    if (hasBilling) return "billing";
    if (hasSecurity) return "security";
    if (hasTickets) return "tickets";
    if (hasGlobalNumbers) return "globalNumber";
    if (hasConfig) return "config";
    return "dashboard";
  };

  const [activeView, setActiveView] = React.useState<string>(getView());

  return (
    <div className='App'>
      <APIOrganisationProvider>
        <Header onSelect={(value: string) => setActiveView(value)} />
        {activeView === "accounts" && renderAccounts()}
        {activeView === "organisations" && renderOrganisations()}
        {activeView === "billing" && renderBilling()}
        {activeView === "tickets" && renderTickets()}
        {activeView === "security" && renderSecurity()}
        {activeView === "globalNumber" && renderGlobalNumber()}
        {activeView === "config" && renderConfig()}
      </APIOrganisationProvider>
    </div>
  );
};

const renderAccounts = () => {
  return (
    <APIAccountProvider>
      <APINumberPoolProvider>
        <AccountView />
      </APINumberPoolProvider>
    </APIAccountProvider>
  );
};

const renderOrganisations = () => {
  return (
    <APIOrganisationProvider>
      <OrganisationView />
    </APIOrganisationProvider>
  );
};

const renderBilling = () => {
  return <BillingView />;
};

const renderConfig = () => {
  return <ConfigView />;
};

const renderTickets = () => {
  return (
    <APITicketProvider>
      <TicketView />
    </APITicketProvider>
  );
};

const renderSecurity = () => {
  return (
    <APIRoleProvider>
      <SecurityView />
    </APIRoleProvider>
  );
};

const renderGlobalNumber = () => {
  return (
    <APINumberPoolProvider>
      <GlobalNumberView />
    </APINumberPoolProvider>
  );
};

export default App;
